import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IState } from '../store';
import { persistUserPreferences } from './persistUserPreferences';

export const toggleShowBaselineInWorkload = createAsyncThunk<void, void, { state: IState }>(
  'uiView/toggleShowBaselineInWorkload',
  (_, { dispatch }) => {
    dispatch(persistUserPreferences());
  }
);
